import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';
import { Strikes } from './expiries/strikes';

export class Expiries extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/expiries`);
  }

  of(id: any) {
    return {
      strikes: new Strikes(this.httpClient, this.pathJoin(id))
    };
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.expiries.forEach((record: any) => this.processRecord(record)))
    );
  }

  get(id: number) {
    return this.api.get(id).pipe(
      tap((json) => this.processRecord(json.expiry))
    )
  }

  getAll() {
    return this.api.get('all').pipe(
      tap((json) => json.expiries.forEach((record: any) => this.processRecord(record)))
    );
  }

  private processRecord(record: any) {
    record.sqrtTs = new BigNumber(record.sqrtTs).fromDecimal();
    record.pvs = new BigNumber(record.pvs).fromDecimal();
  }
}
